<template>
  <div class="control locale-changer-container">
    <div class="select locale-changer">
      <select
        v-model="$i18n.locale"
        @change="setLanguage($i18n.locale)">
        <option
          v-for="lang in locales.locales"
          :value="lang.locale"
          :key="lang.locale">
          {{ lang.short }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  name: "LocaleChanger",
  data() {
    return {
      selected: localStorage.getItem("language")
    };
  },
  computed: {
    ...mapGetters({
      locales: "getLocales"
    })
  },
  created() {
    this.fetchLocales();
  },
  methods: {
    ...mapActions({
      setLanguage: "setLanguage",
      fetchLocales: "fetchLocales"
    })
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";

.locale-changer-container {
  padding-top: 25px;
  padding-left: 10px;
}

.locale-changer select, .locale-changer::after {
  border-color: $secundary !important;
}

</style>
